import React from "react";

function ProfileIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.66637 2.5C5.28566 2.5 4.16637 3.61929 4.16637 5C4.16637 6.38071 5.28566 7.5 6.66637 7.5C8.04708 7.5 9.16637 6.38071 9.16637 5C9.16637 3.61929 8.04708 2.5 6.66637 2.5ZM3.16637 5C3.16637 3.067 4.73337 1.5 6.66637 1.5C8.59937 1.5 10.1664 3.067 10.1664 5C10.1664 6.933 8.59937 8.5 6.66637 8.5C4.73337 8.5 3.16637 6.933 3.16637 5ZM10.833 6C10.833 5.72386 11.0569 5.5 11.333 5.5H14.6664C14.9425 5.5 15.1664 5.72386 15.1664 6C15.1664 6.27614 14.9425 6.5 14.6664 6.5H11.333C11.0569 6.5 10.833 6.27614 10.833 6ZM9.4997 9C9.4997 8.72386 9.72356 8.5 9.9997 8.5H14.6664C14.9425 8.5 15.1664 8.72386 15.1664 9C15.1664 9.27614 14.9425 9.5 14.6664 9.5H9.9997C9.72356 9.5 9.4997 9.27614 9.4997 9ZM4.90436 9.83332C4.93572 9.83333 4.96749 9.83333 4.99971 9.83333H7.9997C8.27585 9.83333 8.4997 10.0572 8.4997 10.3333C8.4997 10.6095 8.27585 10.8333 7.9997 10.8333H4.99971C4.03295 10.8333 3.66042 10.8388 3.37075 10.9266C2.67828 11.1367 2.13639 11.6786 1.92633 12.371C1.83846 12.6607 1.83304 13.0332 1.83304 14C1.83304 14.2761 1.60918 14.5 1.33304 14.5C1.05689 14.5 0.833035 14.2761 0.833035 14C0.833035 13.9678 0.833028 13.936 0.833021 13.9047C0.832835 13.0659 0.832717 12.5313 0.969392 12.0808C1.2764 11.0687 2.0684 10.2767 3.08046 9.96969C3.53102 9.83302 4.06562 9.83313 4.90436 9.83332ZM10.833 12C10.833 11.7239 11.0569 11.5 11.333 11.5H14.6664C14.9425 11.5 15.1664 11.7239 15.1664 12C15.1664 12.2761 14.9425 12.5 14.6664 12.5H11.333C11.0569 12.5 10.833 12.2761 10.833 12Z"
        fill="#59566C"
      />
    </svg>
  );
}

const MemoProfileIcon = React.memo(ProfileIcon);
export default MemoProfileIcon;
